import { TBedrockAgentType, TFeatureConfigSchema } from '@cloud-wave/neon-common-lib';

import { TConfig } from '../../../types/Config';

// if you need to add other stuff to this convert to object based params
export const getIQContextBaseState = (config: TConfig) => {
  const { GEN_AI, PERMISSIONS, AI_SERVICE_URL, TENANT_ID } = config;
  const IQPermissionPrefix = 'AI_';
  const IQFeaturesEnabled = (PERMISSIONS?.filter((value) => value.includes(IQPermissionPrefix)) ||
    []) as TBedrockAgentType[]; // force type conversions as the config context don't

  const IQEnabled = IQFeaturesEnabled.length > 0;
  const IQFeatureConfig = (GEN_AI || {}) as TFeatureConfigSchema['genAI'];

  const aiServiceUrl = `${AI_SERVICE_URL}/agent/${TENANT_ID}`;

  return {
    IQEnabled,
    IQFeaturesEnabled,
    IQFeatureConfig,
    aiServiceUrl,
  };
};
